import React, { useEffect, useState } from 'react';
import styles from './faq.scss';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import { useDispatch } from 'react-redux';
import { makeApiCall } from '../../../services/apiService/apiService';

const pageObj = {
  pageName: 'FAQ',
  beta: false
};

const Faq = () => {
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'faqHtml',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        setData(res.payload);
      }
    }
  };

  useEffect(() => {
    makeApiCall(requestObj);
    dispatch(setPageName(pageObj));
  }, [dispatch]);

  return (
    <div
      className={styles.faqDev}
      dangerouslySetInnerHTML={{ __html: data }}
    ></div>
  );
};

export default Faq;
